/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum FirmwareType {
    Custofw1 = 'CUSTOFW1',
    Custofw2 = 'CUSTOFW2',
    Custofw3 = 'CUSTOFW3',
    Eda = 'EDA',
    Fw = 'FW',
    Loader = 'LOADER',
    Stub = 'STUB',
    Ui = 'UI'
}

export function FirmwareTypeFromJSON(json: any): FirmwareType {
    return FirmwareTypeFromJSONTyped(json, false);
}

export function FirmwareTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FirmwareType {
    return json as FirmwareType;
}

export function FirmwareTypeToJSON(value?: FirmwareType | null): any {
    return value as any;
}

